import toast from 'react-hot-toast';
import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from 'react';

import DataMes from '../componentes/DataMes';
import TituloSessao from '../componentes/TituloSessao';
import AlcanceMensal from '../componentes/graficos/AlcanceMensal';
import HeatMapAlcanceUnidades from '../componentes/graficos/HeatMapAlcanceUnidades';
import BarraBuscaComTodasUnidades from '../componentes/BarraBuscaComTodasUnidades';
import TabelaIndicadorEstabelecimento from '../componentes/graficos/TabelaIndicadorEstabelecimento';
import LineChartDetalhamentoIndicador from '../componentes/graficos/LineChartDetalhamentoIndicador';
import ComposedChartDetalhamentoIndicador from '../componentes/graficos/ComposedChartDetalhamentoIndicador';

import {
    servGetGraficoAlcanceMensal,
    servGetGraficoDetalhamentoMetrica,
    servGetGraficoPercentualAlcanceUnidades,
    servGetTabelaIndicadoresEstabelecimento
} from '../../src/servicos/graficos_indicador';

import { toastErrorPydantic } from '../util/toast_pydantic';

function Graficos() {

    console.log("### INICIANDO GRAFICOS ###");

    const [estabelecimento, setEstabelecimento] = useState(null)
    const [dataInicio, setDataInicio] = useState(null)
    const [dataFim, setDataFim] = useState(null)

    const [alcancePeriodo, setAlcancePeriodo] = useState([])
    const [alcanceMensal, setAlcanceMensal] = useState([])
    const [alcanceUnidades, setAlcanceUnidades] = useState(null)
    const [indicadoresDetalhamento, setIndicadoresDetalhamento] = useState(null)
    const [tabelaIndicadores, setTabelaIndicadores] = useState(null)

    const exibirAvisoGraficos = localStorage.getItem('exibirAvisoGraficos');
    const [modalAviso, setModalAviso] = useState(!exibirAvisoGraficos)

    useEffect(() => {

        // Gráfico mensal
        const getGraficoAlcanceMensal = async () => {
            try {
                const indicadoresMensaisDaApi = await servGetGraficoAlcanceMensal(dataInicio, dataFim)
                setAlcanceMensal(indicadoresMensaisDaApi)
            } catch (erro) {
                toastErrorPydantic(erro)
            }
        }

        // Detalhamento métricas
        const getGraficoDetalhamentoMetrica = async () => {
            try {
                const estabelecimentoId = estabelecimento ? estabelecimento.id : null
                const indicadoresDetalhamentoDaApi = await servGetGraficoDetalhamentoMetrica(dataInicio, dataFim, estabelecimentoId)
                setIndicadoresDetalhamento(indicadoresDetalhamentoDaApi);
            } catch (erro) {
                toastErrorPydantic(erro)
            }
        }

        // Gráfico percentual de unidades HEATMAP
        const getGraficoPercentualAlcanceUnidades = async () => {
            try {
                const dadosHeatMapDaApi = await servGetGraficoPercentualAlcanceUnidades(dataInicio, dataFim)
                setAlcanceUnidades(dadosHeatMapDaApi)
            } catch (erro) {
                toastErrorPydantic(erro)
            }
        }

        // Tabela de indicadores do estabelecimento
        const getTabelaIndicadoresEstabelecimento = async () => {
            try {
                const dadosIndicadoresDaApi = await servGetTabelaIndicadoresEstabelecimento(dataInicio, dataFim, estabelecimento.id)
                setTabelaIndicadores(dadosIndicadoresDaApi)
            } catch (erro) {
                toastErrorPydantic(erro);
            }
        }

        if (dataInicio && dataFim) {
            
            if (dataInicio <= dataFim) {

                getGraficoAlcanceMensal()

                if (!estabelecimento) {
                    getGraficoDetalhamentoMetrica()
                    getGraficoPercentualAlcanceUnidades()
                } else {
                    getGraficoDetalhamentoMetrica()
                    getTabelaIndicadoresEstabelecimento()
                }

            } else {
                toast.error('A Data Início não pode ser maior que a Data Fim');
            }
            
        }

    }, [dataInicio, dataFim, estabelecimento]);

    return (
        <div className='container-fluid d-flex flex-column gap-3 p-3'>

            <Modal show={modalAviso} size="lg" centered >
                <Modal.Header closeButton>
                    <Modal.Title className=''>AVISO</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-3">
                        <p> A partir de abril de 2026, será considerada a matriz de indicadores vigente, com a inclusão do indicador 1.4 – Turnover, conforme estabelecido no
                            {" "}<a
                                href="https://saude.prefeitura.rio/wp-content/uploads/sites/47/2026/05/8_TA_035-2026_CONTRATO_DE_GESTAO_RIOSAUDE_251-2023.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                8º Termo Aditivo
                            </a>{" "}
                            nº 035/2026 ao Contrato de Gestão nº 251/2023. </p>
                        <div className="form-check">
                            <input
                                id='exibirAvisoGraficos'
                                className='form-check-input'
                                type="checkbox"
                                checked={exibirAvisoGraficos}
                                onChange={(e) => localStorage.setItem('exibirAvisoGraficos', !e.target.checked)}
                            />
                            <label className='form-check-label' htmlFor='exibirAvisoGraficos'>
                                Não exibir novamente
                            </label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-primary"
                        onClick={() => setModalAviso(false)}
                    >
                        FECHAR
                    </button>
                </Modal.Footer>
            </Modal>

            <div className='m-0 d-flex flex-column flex-md-row justify-content-center gap-3 p-2 div-com-borda align-items-center' style={{ 'marginTop': '3em' }}>
                <div className='col-12 col-md-2 d-flex gap-1 align-items-center'>
                    <label className='text-nowrap' htmlFor='graf-data-inicial'>Data Inicio</label>
                    <DataMes id='graf-data-inicial' setData={setDataInicio} getUltimoDia={false} />
                </div>
                <div className='col-12 col-md-2 d-flex gap-1 align-items-center'>
                    <label className='text-nowrap' htmlFor='graf-data-final'>Data Fim</label>
                    <DataMes id='graf-data-final' setData={setDataFim} getUltimoDia={true} />
                </div>
                <div className='col-12 col-md-7'>
                    <BarraBuscaComTodasUnidades
                        setEstabelecimento={setEstabelecimento}
                        estabelecimentosVigentes={false}
                        apenasQueEnviamRelatorio={false}
                    />
                </div>
            </div>
            {alcancePeriodo && alcanceMensal && indicadoresDetalhamento && alcanceUnidades
                ?
                (
                    <>
                        <TituloSessao titulo='Alcance mensal dos indicadores de desempenho' barraDecorativa={true} tituloAlignStart={true} />
                        <div style={{ 'height': '25em' }}>
                            <AlcanceMensal
                                dadosGraf={alcanceMensal}
                            />
                        </div>

                        <TituloSessao titulo='Detalhamento dos indicadores' barraDecorativa={true} tituloAlignStart={true} />
                        <ComposedChartDetalhamentoIndicador
                            estabelecimento={estabelecimento}
                            dadosGraf={indicadoresDetalhamento}
                        />

                        {estabelecimento ?  /* Se passar o estabelecimento, mostro a tabela com os indicadores. */
                            <>
                                <TituloSessao titulo='Tabela de indicadores da unidade' barraDecorativa={true} tituloAlignStart={true} />
                                <div className=''>
                                    <TabelaIndicadorEstabelecimento
                                        dadosTabela={tabelaIndicadores}
                                    />
                                </div>
                            </>
                            :
                            <>
                                <TituloSessao titulo='Percentual de unidades que alcançaram determinado indicador' barraDecorativa={true} tituloAlignStart={true} />
                                <div style={{ 'height': '25em' }}>
                                    <HeatMapAlcanceUnidades
                                        dadosGraf={alcanceUnidades}
                                    />
                                </div>
                            </>
                        }
                    </>
                )
                :
                (
                    <div className='text-center'>
                        <p>Selecione ao menos uma <strong>data início</strong> e uma <strong>data fim</strong> para buscar as informações no banco de dados</p>
                    </div>
                )
            }
        </div>
    );
}

export default Graficos
